import React from 'react'

export default class IconRadio extends React.Component {
    outerStyle() {
        return this.props.inactive ? Styles.outer.inactive : Styles.outer.active
    }

    innerStyle() {
        return this.props.inactive ? Styles.inner.inactive : Styles.inner.active
    }

    render() {
        return (
            <svg style={Styles.svg} viewBox="0 0 28 28">
                <g transform="translate(2 2)" fill="none" fillRule="evenodd">
                    <circle style={this.outerStyle()} strokeWidth="3" cx="12" cy="12" r="12" />
                    <circle style={this.innerStyle()} fill="#06C595" cx="12" cy="12" r="7" />
                </g>
            </svg>
        )
    }
}

const Styles = {
    svg: {
        width: '28px',
        height: '28px'
    },

    inner: {
        inactive: {
            fill: 'transparent'
        },

        active: {
            fill: '#06C595'
        }
    },

    outer: {
        inactive: {
            stroke: '#D8D8D8'
        },

        active: {
            stroke: '#06C595'
        }
    }
}
